/**
 * 数量・金額などの数値入力で全角入力を受け付け、半角へ正規化するためのユーティリティ。
 * 全角数字（０-９）・全角マイナス（－ー−）・全角ピリオド（．）を半角へ変換する。
 */
export function toHalfWidth(input: string): string {
  return input
    .replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
    .replace(/[．。]/g, '.')
    .replace(/[－ー−‐―]/g, '-');
}

/**
 * 数量など「0以上の整数」入力を正規化する。全角→半角変換後に数字以外を除去し、数値を返す。
 * 空文字の場合は 0。
 */
export function parseQuantityInput(input: string): number {
  const raw = toHalfWidth(input).replace(/[^\d]/g, '');
  return raw === '' ? 0 : Number(raw);
}
